import React from 'react'
import NavLink from '../Routes/NavLink'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory, match } from 'react-router';

import { workOrders } from '../../core/controllers/WorkOrders';

export default class WorkOrdersBuildingList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workOrders: {}
        }
    }

    componentDidMount() {
        var self = this;
        workOrders.getWorkOrdersWithBuildingId(this.props.buildingId, function(response){
            if(response.data.length > 0) {
                self.setState({
                    workOrders: response.data
                });
            }
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatAssignee(cell, row) {
        if(row.assignee_id != "0") {
            return (
                <span onClick={this}>
                    <NavLink to={"/user/" + row.assignee_id}>View Assignee</NavLink>
                </span>
                )
        } else {
            return "No Assignee";
        }
    }

    formatDateCreated(cell, row) {
        return moment.utc(row.created_at).local().format('D MMM YYYY h:mm A');
    }

    didSelectRow(row) {
        browserHistory.push('/maintenance/order/' + row.work_order_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var workOrders;
        const options = {
            onRowClick: this.didSelectRow
        };

        if(this.state.workOrders !== null && this.state.workOrders.length > 0) {
            workOrders = this.state.workOrders.map(function(workOrder) {
                return self.flattenObject(workOrder);
            });
        }

        return (
            <div class="content">
                <BootstrapTable data={workOrders} version='4' striped search pagination options={options}>
                    <TableHeaderColumn width="50" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                    <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                    <TableHeaderColumn dataField='work_order_type' dataSort={ true }>Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                    <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.formatAssignee.bind(this.stopSelectRow)}>Contractor</TableHeaderColumn>
                    <TableHeaderColumn dataField='created_at' dataFormat={this.formatDateCreated}>Submitted</TableHeaderColumn>
                </BootstrapTable>
                <div class="content">
                    <NavLink to={"/maintenance/order/new"}>
                        <button type="button" id="add-work-order" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off">Add Work Order</button>
                        <div class="clearfix"></div>
                    </NavLink>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrders/WorkOrdersBuildingList.jsx